import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "ESBuild, sans-serif",
          textTransform: "none",
          minWidth: "unset",
          boxShadow: "none",
          '&:hover': {
            boxShadow: "none"
          },

          '&.MuiButton-sizeSmall': {
            fontWeight: '400',
            fontSize: '13px',
            lineHeight: '22px',
            letterSpacing: '0.46px',
            padding: '4px 5px',
            textAlign: 'center'
          },
          '&.MuiButton-sizeMedium': {
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '24px',
            letterSpacing: '0.4px',
            padding: '6px 8px',
            textAlign: 'center'
          },
          '&.MuiButton-sizeLarge': {
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '26px',
            letterSpacing: '0.46px',
            padding: '8px 11px',
            textAlign: 'center'
          },
        },
      },
    },
  },
});

export default theme;
